import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { getGroups } from "../actions/groupActions";
//import { getActiveSettings } from "../actions/supplierActions";
//import { Link } from "react-router-dom";
import UserAvatar from "../components/UserAvatar";
import { withTranslation } from 'react-i18next';
import { SitePageContentTypeEnum } from "../common/enums";
import { utils } from "../common/utils";
import ExtendedLink  from "../components/ExtendedLink";

class SideMenu extends Component {
    componentDidMount() {
        this.loadGroups();
    }

    // Reload the groups with the new locale
    componentDidUpdate(prevProps) {

        if ( this.props.locale !== prevProps.locale) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
        {
            this.loadGroups();
        }
    }

    loadGroups() {
        this.props.getGroups(this.props.activePage, this.props.settings.pageSize);
    }

    render() {
        const { groups, user, settings, siteLinks, locale } = this.props;
        if (!groups || settings.isCatalogueMode || settings.isAppMode  === true) return <div />;

        var groupsList = groups.items.map(group => (
            <li key={group.id} className="has-children">
                <span>
                    <ExtendedLink className='offcanvas-menu-link' to={`${settings.baseUrl}categories/${group.id}`}>{group.name}</ExtendedLink>
                </span>
            </li>
        ));

        let linkIndex = 0;
        const localeSideMenuLinks = siteLinks && siteLinks.sideMenuLinks ? siteLinks.sideMenuLinks.filter(link => (utils.isNullOrEmpty(link.locale) || link.locale === locale)) : [];
        const sideMenuLinks = localeSideMenuLinks.map(link => {
            if (link.contentType === SitePageContentTypeEnum.Url) {
                return (
                    <li key={++linkIndex} className="has-children">
                        <span>
                            <a rel="noopener noreferrer" className='offcanvas-menu-link' target={link.target}
                                href={utils.getLinkUrl(link, settings)}>{link.name}</a>
                        </span>
                    </li>
                );
            } else {
                return (<li key={++linkIndex} className="has-children">
                    <span>
                        <ExtendedLink className='offcanvas-menu-link'
                            to={`${settings.baseUrl}page/${link.id}`}>{link.name}</ExtendedLink>
                    </span>
                </li>);
            }

    });

        return ( <Fragment>
                <div className="offcanvas-container" id="shop-categories">
                <UserAvatar settings={settings} user={user} />
                    <nav className="offcanvas-menu">
                    <ul className="menu">{groupsList}{sideMenuLinks}</ul>
                    </nav>
                </div>
                <div className="offcanvas-container" id="mobile-menu">
                <UserAvatar settings={settings} user={user} />
                    <nav className="offcanvas-menu">
                    <ul className="menu">{groupsList}{sideMenuLinks}</ul>
                    </nav>
                </div>
                </Fragment>
        );
    }
}

function mapStateToProps({ groups, user, settings, siteLinks, activePage, locale }, ownProps) {
    return { groups, user, settings, siteLinks, activePage, locale, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, { getGroups/*, getActiveSettings */})(SideMenu));
